let _add = null;

export function registerToast(addFn) {
  _add = addFn;
}

export function showToast(severity, detail, life = 6000) {
  if (!_add) return;
  const summary = severity === 'success' ? 'Éxito'
    : severity === 'warn' ? 'Aviso'
    : 'Error';
  _add({ severity, summary, detail, life });
}
